import { useState, useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../../../utils/init-firebase';
import { User, COLLECTION_NAMES } from '../types';

/**
 * Hook for managing Users data with Firestore
 * Provides real-time user list for L10 Meeting and other EOS features
 */
export function useUsers() {
  const { eosUsers = [] } = useAuth();
  
  // Return eosUsers mapped to User type structure if needed,
  // but eosUsers already fits User interface mostly.
  // We'll just return it directly as the source of truth for "Users" in EOS module
  return { 
    users: eosUsers, 
    loading: false 
  };
}

